import getMinigameByName from "../getMinigameByName";

export function getNonCompTasksByName(mgName, config, history){
    return dropFinished(
        getTaskNames(getMinigameByName(mgName, config), []),
        history
    );
}

export function getNonCompTasks(mg, history){
    let taskNames = getTaskNames(mg, []);
    return dropFinished(
        taskNames,
        history
    );
}

export function getTaskNames(minigame, array){
    if(!minigame) return [];

    if(!minigame.components){
        array.push(minigame.name);
    }
    else{
        for(let task of minigame.components.sequence){
            getTaskNames(task, array);
        }
    }
    return array;
}

function finishedMinigames(history) {
	return history.filter(({ finished }) => finished).map(({ minigame: { name } }) => name);
}
function dropFinished(tasks, history) {
	const finished = finishedMinigames(history);
	return tasks.filter(name => !finished.includes(name));
}